<div class="dialog-header-container">
  <h1 mat-dialog-title class="mar-b-5 pd-t-5px">Description</h1>
  <div>
    <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon">
        <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class = "mat-divider"></mat-divider>
<form [formGroup]="agEditDiaolg"> 
<div class="content-container">
  <div mat-dialog-content class="dialog-with-actions">
    <div class="text-container mar-t-5">
      <mat-form-field class="text-area-container"> 
        <mat-label>Description</mat-label>       
        <textarea formControlName="agendaDesc" matInput></textarea>
      </mat-form-field>
      <!-- <button class="global-icn-bttn-container" mat-mini-fab><mat-icon>add</mat-icon></button> -->
    </div>
  </div>
  <div mat-dialog-actions class="button-actions-container">
    <button (click)="updateDesc()" mat-button class="button-container primary">Save</button>
    <button mat-button class="button-container primary" mat-dialog-close>Cancel</button>
  </div>
</div>
</form>